import ChampionImageWithLane from "../common/ChampionImageWithLane";
import React from "react";
import styled from "styled-components";


const ChampionImageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 4px solid ${props => {
    let color = '#E85C5C'
    if (props.isWin) {
      color = '#4C92FC';
    }
    if(props.noColor) {
        color = 'transparent'
    }
    if(props.disabled) {
        color = props.theme.color.default_border_color
    }
    return color
  }};

  .imgDiv {
    border-radius: 100%;
  }
`;

const EmptyChampionImageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 4px solid ${props => props.theme.color.default_border_color};
  border-radius: 100%;
`;
const EmptyImage = styled.div`
  border-radius: 100%;
  background-color: ${props => props.theme.color.default_border_color};
`;
const ImageWrapper = styled.div`
  border-radius: 100%;
    margin: 3px;
`;
const LLMChampionImage = ({championId,noColor,isWin,disabled,disableChampion}) => {


    if (!championId) {
        return (
            <EmptyChampionImageBox>
                <ImageWrapper>
                    <EmptyImage className={'imgChampEmpty'}/>
                </ImageWrapper>
            </EmptyChampionImageBox>
        )
    }

    return (
        <ChampionImageBox isWin={isWin} noColor={noColor} disabled={disabled}>
            <ImageWrapper>
                <ChampionImageWithLane champion_id={championId} disableScale={true} imgSize={100} disabled={disableChampion}/>
            </ImageWrapper>
        </ChampionImageBox>
    )
}

export default LLMChampionImage